module.exports = __webpack_public_path__ + "static/media/red2.62794c4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/red2.svg
// module id = 1337
// module chunks = 31